export const iconFontAwesomeMarketingAnchor = (
	<i className="fa-solid fa-anchor"></i>
);
